import React from 'react';
import PropTypes from 'prop-types';
import Translate from '../../i18n/Translate/Translate';
import './ColorMsg.scss';

const ColorMsg = ({ type, msg, icon }) => (
  <div className={`color-msg color-msg__${type} d-flex mt-2 mb-2 p-2 font-14`}>
    {icon && <img src={icon} alt="icon" className="mr-2" />}
    <Translate translationKey={msg} />
  </div>
);

ColorMsg.defaultProps = {
  icon: '',
};

ColorMsg.propTypes = {
  type: PropTypes.string.isRequired,
  msg: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

export default ColorMsg;
